import { render, staticRenderFns } from "./noAccessToComapnySurvey.vue?vue&type=template&id=1f395880&scoped=true"
import script from "./noAccessToComapnySurvey.vue?vue&type=script&lang=js"
export * from "./noAccessToComapnySurvey.vue?vue&type=script&lang=js"
import style0 from "./noAccessToComapnySurvey.vue?vue&type=style&index=0&id=1f395880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f395880",
  null
  
)

export default component.exports